import axios from 'axios';

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // api的base_url
});

// request拦截器
service.interceptors.request.use((config) => {
  const { token } = window;
  if (token) {
    config.headers['Access-Token'] = token;
  }

  return config;
}, (error) => {
  Promise.reject(error);
});

// response拦截器
service.interceptors.response.use((response) => {
  if (response.status) {
    const { data } = response;

    // 统一错误处理
    if (data.status !== 0) {
      wx.miniProgram.navigateBack();
    }
    return data;
  }
  return response;
},
error => Promise.reject(error));

export default service;
